export default "__VITE_ASSET__6649b917__"